import React, { useContext } from "react";

export type GanttDataContextType = {
  mapGroupD1?: Sentinel.Timeline.GroupedEvent[];
  mapGroupD2?: Sentinel.Timeline.GroupedEvent[];
  rawData?: Sentinel.Timeline.New;
  updateData?: (data: Sentinel.Timeline.New) => void;
  refreshMap?: () => void;
};

const GanttDataContext = React.createContext<GanttDataContextType>({});

export const useGanttDataContext = () => useContext(GanttDataContext);

export default GanttDataContext;
